<div
  flex
  flexLayout="row"
  flexLayoutAlign="start center"
  flexLayoutGap=".5rem"
  *ngIf="items && items.length > 0"
>
  <span>Active Filters</span>
  <mat-icon matTooltip="Active Filters">filter_list</mat-icon>
  <mat-chip-set>
    <mat-chip
      *ngFor="let item of items; trackBy: trackByValue"
      [removable]="true"
      [disableRipple]="true"
      (removed)="removedHandler(item)"
    >
      <mat-icon [matTooltip]="item.label">filter_alt</mat-icon>
      {{ item.label | replaceString: "-":" " | titlecase }}
      <!-- <div>{{ item.label | replaceString: "-":" " | titlecase }}</div> -->
      <mat-icon matChipRemove matTooltip="Clear this filter">cancel</mat-icon>
    </mat-chip>
  </mat-chip-set>
  <button mat-icon-button matTooltip="Clear all filters" (click)="clearAllHandler()">
    <mat-icon>clear</mat-icon>
  </button>
</div>
